import { IpaOrFeature } from "../pattern/convertPattern";
import { Pattern } from "../pattern/pattern";
import { SyllablePhonotactics } from "./phonotactics";

const liquid: Pattern<IpaOrFeature> = { or: ['/l/', '/ɾ/'] };
const semivowel: Pattern<IpaOrFeature> = { or: ['/w/', '/j/'] };
const consonant: Pattern<IpaOrFeature> = { and: [':consonant', { not: semivowel }] };

// supports Mexican Spanish
// note that the one set of words that don't match have a Cwj pattern in them, e.g., muiendo: '/mwjendo/'
export const spanishPhonotactics: SyllablePhonotactics<IpaOrFeature> = {
  affricates: 'en-aff',
  onset: {
    or: [
      { seq: [':plosive', liquid] },
      { seq: [{ or: ['/f/', '/β/', '/ɣ/', '/ð/'] }, liquid] },
      consonant,
      '',
    ]
  },
  nucleus: {
    or: [
      { seq: [semivowel, ':vowel', semivowel] },
      { seq: [semivowel, ':vowel'] },
      { seq: [':vowel', semivowel] },
      { seq: [':vowel', ':non-syllabic'] },
      ':vowel',
    ]
  },
  coda: {
    or: [
      { seq: [consonant, { or: ['/s/', '/z/'] }] },
      consonant,
      '',
    ]
  },
}
